module.exports = __webpack_public_path__ + "static/img/1.0736639.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CorporateTravel/1.png
// module id = ofNv
// module chunks = 1